// ** Next Imports
import { useRouter } from 'next/router'

import React from 'react'
import { useEffect, useState } from 'react'

import BlogReviewDataList from 'src/@core/components/blog-review/BlogReviewDataList'

// ** Utils
import { getObjectValueWithDefaultValue } from 'src/@core/utils/utils'
import isEmpty from 'lodash/isEmpty'

//  Services
import { useReviewData } from '../../@core/services/firestore/hooks/useReviewData'
import { useTranslation } from 'next-i18next'
import { useAuth } from '../../@core/context/AuthUserContext'
// import { updateAllBatch } from 'src/@core/services/firestore/'

// Redux
import { connect } from 'react-redux'
import { compose } from 'redux'
import { updateDeviceInfo } from 'src/@core/redux/actions'

// ** SSR
import getServerSideProps from 'src/@core/services/ssr/serverProps'

export { getServerSideProps }

//  Constants
import { PAGINATION } from '../../constants/Constants'

const BlogReviewPage = props => {
  const { t } = useTranslation()

  // State
  const reviewHookData = useReviewData()
  const { dbUser } = useAuth()

  // Paging
  const [reviewDataList, setReviewDataList] = useState([])
  // const [textSearch, setTextSearch] = useState('')
  // const [originSearch, setOriginSearch] = useState('')
  const [loadingData, setLoadingData] = useState(true)
  const [previousPage, setPreviousPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(PAGINATION.REVIEW)

  // ** Hooks
  const router = useRouter()

  useEffect(() => {
    if (!isEmpty(props.deviceInfo)) {
      props.updateDeviceInfo(props.deviceInfo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.deviceInfo])

  useEffect(() => {
    reviewHookData.actions.subscribeReviewCounter()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const previousPage = getObjectValueWithDefaultValue(router.query, 'prePage', 1)
    const currentPage = getObjectValueWithDefaultValue(router.query, 'page', 1)
    // const numberLimit = getObjectValueWithDefaultValue(router.query, 'limit', PAGINATION.REVIEW)
    const numberLimit = rowsPerPage
    const lastTime = getObjectValueWithDefaultValue(router.query, 'lastTime', '0')

    //
    setPreviousPage(previousPage)
    setCurrentPage(currentPage)
    //
    getCurrentData(previousPage, currentPage, numberLimit, lastTime)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query])

  // useEffect(() => {
  //   getCurrentData(previousPage)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPage])

  //
  async function getCurrentData(previousPage, currentPage, numberLimit, lastTime) {
    //
    await reviewHookData.actions.getCurrentAllReviewData(previousPage, currentPage, numberLimit, lastTime)
  }

  useEffect(() => {
    if (!isEmpty(reviewHookData.reviewDataList)) {
      setReviewDataList(reviewHookData.reviewDataList)
      //
      setLoadingData(false)
    } else {
      if (loadingData === true) {
        setReviewDataList(reviewHookData.reviewDataList || [])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reviewHookData.reviewDataList])

  const handleChangePage = newPage => {
    if (currentPage && currentPage !== newPage) {
      const fieldValue = 'testDate'
      let lastTimeData = ''
      let previousPageData = currentPage
      let currentPageData = newPage
      const posts = reviewDataList
      if (newPage < currentPage) {
        if (posts.length > 0) {
          const productItem = posts[0]
          lastTimeData = productItem[fieldValue]
        }
      } else {
        if (posts.length > 0) {
          const productItem = posts[posts.length - 1]
          lastTimeData = productItem[fieldValue]
        }
      }
      //
      const queryURL = {}
      if (previousPageData && previousPageData != currentPageData) {
        queryURL.prePage = previousPageData
      }
      if (currentPageData) {
        queryURL.page = currentPageData
      }
      if (lastTimeData) {
        queryURL.lastTime = lastTimeData
      }
      router.push({
        pathname: router.pathname,
        query: queryURL
      })
    }
    // if (currentPage === newPage - 1 || currentPage === newPage + 1) {
    //   setPreviousPage(currentPage)
    //   setCurrentPage(newPage)
    // }
  }

  const handleChangeRowsPerPage = number => {
    setRowsPerPage(number)
    setCurrentPage(1)
  }

  return (
    <BlogReviewDataList
      title={t('general.page_review_title')}
      subTitle={t('general.page_review_description')}
      dbUser={dbUser}
      needBadge={false}
      needAction={false}
      needAdd={true}
      isOpenPageDetail={true}
      loading={loadingData}
      previousPage={previousPage}
      currentPage={currentPage}
      rowsPerPage={rowsPerPage}
      dataList={reviewDataList}
      counterData={reviewHookData.reviewCounterData}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
    />
  )
}

export function mapDispatchToProps(dispatch) {
  return {
    updateDeviceInfo: value => dispatch(updateDeviceInfo(value))
  }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(React.memo, withConnect)(BlogReviewPage)
